import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { CaseHistoryStore } from "Store";
import HeaderView from "module-case-management/content-panel/header/HeaderView";
import MessageList from "module-case-management/content-panel/message-list/MessageListWithStoreQuery";
import EmptyPanel from "module-case-management/content-panel/EmptyPanel";
import Button from "module-common/Button";
import Avatar from "module-common/Avatar";

export default class CaseJourney extends Component {
  static propTypes = {
    id: PropTypes.number,
    caseId: PropTypes.number,
    case: PropTypes.object,
    image: PropTypes.string,
    nameFrom: PropTypes.string,
    content: PropTypes.string,
    channel: PropTypes.string,
    dateBegin: PropTypes.string,
    dateEnd: PropTypes.string
  };

  state = {
    isShown: false
  };

  renderBubble = cardId => {
    const { caseId, id } = this.props;
    const { case: getCases } = this.props;
    const store = CaseHistoryStore;

    if (cardId === id) {
      store.selectedCase = getCases;
      this.setState({
        isShown: true
      });
    }
  };

  closeBubble = cardId => {
    const { id } = this.props;
    const store = CaseHistoryStore;

    if (cardId === id) {
      store.selectedCase = null;
      this.setState({
        isShown: false
      });
    }
  };

  render() {
    const {
      id,
      caseId,
      image,
      nameFrom,
      content,
      channel,
      dateBegin,
      dateEnd
    } = this.props;
    const { selectedCase } = CaseHistoryStore;

    return (
      <Wrapper>
        <CardContainer onClick={cardId => this.renderBubble(id)}>
          <AvatarWrapper image={image} />
          <Content>
            <Name>{nameFrom}</Name>
            <LastChat>{content}</LastChat>
            {/* <Label>VIP</Label> */}
          </Content>
          <Date>
            Begin: {dateBegin} - End: {dateEnd}
          </Date>
        </CardContainer>

        {selectedCase && this.state.isShown ? (
          <BubbleContainer>
            <MessageList
              key={"MessageList-" + selectedCase.id}
              case={{ id: selectedCase.id }}
              store={CaseHistoryStore}
            />
            <Button onClick={cardId => this.closeBubble(id)}>close</Button>
          </BubbleContainer>
        ) : null}
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 500px;
  border: 1px solid #e1dfde;
  border-radius: 4px;
  &:hover {
    border: 1px solid #338dca;
  }
`;

const CardContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  cursor: pointer;
  border-bottom: 1px solid #e1dfde;
  padding: 10px;
`;

const AvatarWrapper = styled(Avatar)`
  margin-right: 10px;
  height: 30px;
  width: 30px;
`;

const Content = styled.div`
  display: flex;
  flex: 2;
  flex-direction: column;
`;

const Name = styled.div`
  font-weight: 700;
  font-size: 14px;
`;

const LastChat = styled.div``;

const Label = styled.div``;

const Date = styled.div`
  right: 10px;
  position: absolute;
  font-size: 10px;
`;

const BubbleContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 300px;
  width: 500px;
  padding-right: 2px;
`;



// WEBPACK FOOTER //
// ./src/module-customer-journey/detail/chat/CaseJourney.js